import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import { ChangeEvent } from 'react';
import css from './Switch.module.scss';

export interface SwitchProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  isLoading?: boolean;
  /** id for the underlying checkbox, so an external `<label htmlFor>` can toggle it. */
  id?: string;
}

export const Switch = ({
  checked,
  onChange,
  disabled = false,
  className,
  isLoading = false,
  id,
}: SwitchProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <div className={css.switchContainer}>
      <label
        className={classNames(
          css.switch,
          {
            [css.disabled]: disabled || isLoading,
          },
          className,
        )}
      >
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled || isLoading}
        />
        <span className={classNames(css.slider)} />
      </label>
      {isLoading && (
        <div className={css.loadingOverlay}>
          <CircularProgress size={16} />
        </div>
      )}
    </div>
  );
};
